import React, { useEffect, useState } from "react";
import { wpBase } from "../store/api/base";
import { useDispatch } from "react-redux";
import { setFormId } from "../store/slices/details.slice";

const MessageIdFetcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchMessageId = async () => {
      try {
        const response = await wpBase.get("/listings", {
          headers: {
            "Content-Type": "text/html",
          },
        });

        const parser = new DOMParser();
        const doc = parser.parseFromString(response.data, "text/html");
        const inputElement = doc.querySelector(
          'input[type="hidden"]#messageId'
        );

        if (inputElement) {
          const messageIdValue = inputElement.getAttribute("value");
          dispatch(setFormId(messageIdValue));
        } else {
          console.error("Element with ID messageId not found");
        }
      } catch (error) {
        console.error("Error fetching the URL:", error);
      }
    };

    fetchMessageId();
  }, []);

  return <></>;
};

export default MessageIdFetcher;
